import { put, call } from "redux-saga/effects";
import { push } from 'react-router-redux';
import Swal from "sweetalert2";
import {
    getSidebarMenuSuccess, getSidebarMenuFail,
    getAllSidebarMenusSuccess, getAllSidebarMenusFail,
    getOrderedSidebarMenusSuccess, getOrderedSidebarMenusFail,
    getSidebarMenusByRoleSuccess, getSidebarMenusByRoleFail,
    getSidebarMenusByStatusSuccess, getSidebarMenusByStatusFail,
    getRootSidebarMenusSuccess, getRootSidebarMenusFail,
    getChildSidebarMenusSuccess, getChildSidebarMenusFail,
    createSidebarMenuSuccess, createSidebarMenuFail,
    updateSidebarMenuSuccess, updateSidebarMenuFail,
    deleteSidebarMenuSuccess, deleteSidebarMenuFail,
    setSidebarMenuLoading, getSidebarMenusByRoleAdminSuccess, getSidebarMenusByRoleAdminFail
} from "../actions/sidebarMenuActions";
import {
    API_BASE_URL,
    getRequest,
    putRequest,
    deleteRequest,
    postRequest
} from "../../../api";


export function* getSidebarMenuSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/sidebar-menus/${action.payload.menuId}`;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 GET_SIDEBAR_MENU_REQUEST');
        console.log('📊 Menu ID:', action.payload.menuId);
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token, uid });

        console.group('✅ GET_SIDEBAR_MENU_SUCCESS');
        console.log('📥 Réponse API:', resp.data);
        console.groupEnd();

        yield put(getSidebarMenuSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

    } catch (error) {
        console.group('❌ GET_SIDEBAR_MENU_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getSidebarMenuFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* getAllSidebarMenusSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/sidebar-menus`;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 GET_ALL_SIDEBAR_MENUS_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token, uid });

        console.group('✅ GET_ALL_SIDEBAR_MENUS_SUCCESS');
        console.log('📥 Nombre de menus:', resp.data.length);
        console.groupEnd();

        yield put(getAllSidebarMenusSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

    } catch (error) {
        console.group('❌ GET_ALL_SIDEBAR_MENUS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getAllSidebarMenusFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* getOrderedSidebarMenusSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/sidebar-menus/ordered`;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 GET_ORDERED_SIDEBAR_MENUS_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_ORDERED_SIDEBAR_MENUS_SUCCESS');
        console.log('📥 Nombre de menus ordonnés:', resp.data.length);
        console.groupEnd();

        yield put(getOrderedSidebarMenusSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

    } catch (error) {
        console.group('❌ GET_ORDERED_SIDEBAR_MENUS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getOrderedSidebarMenusFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* getSidebarMenusByRoleAdminSaga(action) {
    const token = sessionStorage.getItem("token");
    const url = `${API_BASE_URL}/api/sidebar-menus/role/${action.payload.roleId}/company/${action.payload.companyId}`;
    yield put(setSidebarMenuLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getSidebarMenusByRoleAdminSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));
    } catch (error) {
        yield put(getSidebarMenusByRoleAdminFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* getSidebarMenusByRoleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/sidebar-menus/role/${action.payload.roleId}/company/${action.payload.companyId}`;

    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 GET_SIDEBAR_MENUS_BY_ROLE_REQUEST');
        console.log('📊 Role ID:', action.payload.roleId);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_SIDEBAR_MENUS_BY_ROLE_SUCCESS');
        console.log('📥 Nombre de menus:', resp.data.length);
        console.groupEnd();

        // Keep the role that produced this response so the UI never redirects
        // from the menus that were still displayed for the previous role.
        yield put(getSidebarMenusByRoleSuccess(resp.data, action.payload.roleId));
        yield put(setSidebarMenuLoading(false));

    } catch (error) {
        console.group('❌ GET_SIDEBAR_MENUS_BY_ROLE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getSidebarMenusByRoleFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* getSidebarMenusByStatusSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/sidebar-menus/status/${action.payload.status}`;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 GET_SIDEBAR_MENUS_BY_STATUS_REQUEST');
        console.log('📊 Status:', action.payload.status);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_SIDEBAR_MENUS_BY_STATUS_SUCCESS');
        console.log('📥 Nombre de menus:', resp.data.length);
        console.groupEnd();

        yield put(getSidebarMenusByStatusSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

    } catch (error) {
        console.group('❌ GET_SIDEBAR_MENUS_BY_STATUS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getSidebarMenusByStatusFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* getRootSidebarMenusSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/sidebar-menus/root`;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 GET_ROOT_SIDEBAR_MENUS_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_ROOT_SIDEBAR_MENUS_SUCCESS');
        console.log('📥 Nombre de menus racines:', resp.data.length);
        console.groupEnd();

        yield put(getRootSidebarMenusSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

    } catch (error) {
        console.group('❌ GET_ROOT_SIDEBAR_MENUS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getRootSidebarMenusFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* getChildSidebarMenusSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/sidebar-menus/parent/${action.payload.parentId}`;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 GET_CHILD_SIDEBAR_MENUS_REQUEST');
        console.log('📊 Parent ID:', action.payload.parentId);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_CHILD_SIDEBAR_MENUS_SUCCESS');
        console.log('📥 Nombre de menus enfants:', resp.data.length);
        console.groupEnd();

        yield put(getChildSidebarMenusSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

    } catch (error) {
        console.group('❌ GET_CHILD_SIDEBAR_MENUS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getChildSidebarMenusFail(error.message));
        yield put(setSidebarMenuLoading(false));
    }
}

export function* createSidebarMenuSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/sidebar-menus`;
    const data = action.payload;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 CREATE_SIDEBAR_MENU_REQUEST');
        console.log('📊 Données:', data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data, token, uid });

        console.group('✅ CREATE_SIDEBAR_MENU_SUCCESS');
        console.log('📥 Menu créé:', resp.data);
        console.groupEnd();

        yield put(createSidebarMenuSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Menu créé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        if (action.history) {
            yield put(push('/sidebar-menus'));
        }

    } catch (error) {
        console.group('❌ CREATE_SIDEBAR_MENU_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(createSidebarMenuFail(error.message));
        yield put(setSidebarMenuLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la création",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* updateSidebarMenuSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/sidebar-menus/${action.payload.menuId}`;
    const data = action.payload.menuData;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 UPDATE_SIDEBAR_MENU_REQUEST');
        console.log('📊 Menu ID:', action.payload.menuId);
        console.log('📊 Nouvelles données:', data);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data, token, uid });

        console.group('✅ UPDATE_SIDEBAR_MENU_SUCCESS');
        console.log('📥 Menu mis à jour:', resp.data);
        console.groupEnd();

        yield put(updateSidebarMenuSuccess(resp.data));
        yield put(setSidebarMenuLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Menu mis à jour avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ UPDATE_SIDEBAR_MENU_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(updateSidebarMenuFail(error.message));
        yield put(setSidebarMenuLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la mise à jour",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* deleteSidebarMenuSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/sidebar-menus/${action.payload.menuId}`;
    yield put(setSidebarMenuLoading(true));

    try {
        console.group('🔵 DELETE_SIDEBAR_MENU_REQUEST');
        console.log('📊 Menu ID:', action.payload.menuId);
        console.groupEnd();

        yield call(deleteRequest, { url, token, uid });

        console.group('✅ DELETE_SIDEBAR_MENU_SUCCESS');
        console.log('🗑️ Menu supprimé');
        console.groupEnd();

        yield put(deleteSidebarMenuSuccess(action.payload.menuId));
        yield put(setSidebarMenuLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: "Menu supprimé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        if (action.history) {
            yield put(push('/sidebar-menus'));
        }

    } catch (error) {
        console.group('❌ DELETE_SIDEBAR_MENU_FAIL');
        console.error('🚨 Erreur complète:', error);
        console.error('🚨 Response data:', error.response?.data);
        console.error('🚨 Response status:', error.response?.status);
        console.groupEnd();

        yield put(setSidebarMenuLoading(false));

        // Extraire le message d'erreur
        let errorMessage = "Erreur lors de la suppression";

        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
        } else if (error.message) {
            errorMessage = error.message;
        }

        // Gestion spécifique de l'erreur de contrainte de clé étrangère
        if (error.response?.data?.error === 'FOREIGN_KEY_CONSTRAINT') {
            errorMessage = error.response.data.message;
        }

        yield put(deleteSidebarMenuFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur de suppression',
            text: errorMessage,
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });
    }
}
